export default __webpack_public_path__ + "static/media/ic_arrow_back.ceecbfa5.svg";